import { Button as ButtonMui } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'

const COLORS = {
	white: 'white',
	whiteLight: 'text.white',
	black: 'black',
}

const BG_COLORS = {
	green: 'success.main',
	blue: 'secondary.main',
	white: 'white',
}

const Button = ({ label, href, color, bgColor, ml, mt, endIcon, bColor, type, target }) => {
	return (
		<ButtonMui
			sx={(theme) => ({
				position: 'relative',
				fontSize: 16,
				p: (theme) => theme.spacing(3, 4),
				bgcolor: BG_COLORS[bgColor],
				color: COLORS[color],
				fontWeight: 700,
				my: theme.spacing(2),
				mx: 0,
				ml: ml || 0,
				whiteSpace: 'nowrap',
				textTransform: 'none',
				minWidth: 169,
				border: (bColor && `3px solid ${theme.palette.secondary.main}`) || 'none',

				'&:hover': {
					bgcolor: BG_COLORS[bgColor],
					border: (bColor && `3px solid ${theme.palette.secondary.main}`) || 'none',
				},

				[theme.breakpoints.down('md')]: {
					display: 'flex',
					m: theme.spacing(0, 'auto'),
					mt: mt || 10,

					'a&': {
						display: 'flex',
						p: 3,
						border: 'none',
					},
				},
			})}
			variant={(bColor && 'outlined') || 'contained'}
			href={href}
			endIcon={endIcon}
			type={type}
			target={target}
		>
			{label}
		</ButtonMui>
	)
}

Button.defaultProps = {
	color: 'black',
	bgcolor: 'blue',
	href: '',
}

Button.propTypes = {
	label: PropTypes.string.isRequired,
	color: PropTypes.string,
	bgcolor: PropTypes.string,
	href: PropTypes.string,
}

export default Button
